export default {
  "Display <1><0>10</0><1>20</1><2>50</2><3>100</3></1> items per page": "每页显示 <1><0>10</0><1>20</1><2>50</2><3>100</3></1> 条",
  "Meet <1><0>All</0><1>Any</1></1> conditions in the group": "满足组内 <1><0>全部</0><1>任意</1></1> 条件",
  "Open in<1><0>Modal</0><1>Drawer</1><2>Window</2></1>": "在 <1><0>对话框</0><1>抽屉</1><2>窗口</2></1> 内打开",
  "{{count}} filter items": "{{count}} 个筛选项",
  "{{count}} more items": "还有 {{count}} 项",
  "Total {{count}} items": "总共 {{count}} 条",
  "Today": "今天",
  "Month": "月",
  "Week": "周",
  "Work week": "工作日",
  "Day": "天",
  "Agenda": "列表",
  "Date": "日期",
  "Time": "时间",
  "Event": "事件",
  "None": "无",
  "System settings": "系统设置",
  "System title": "系统名称",
  "Logo": "Logo",
  "Add menu item": "添加菜单项",
  "Page": "页面",
  "Name": "名称",
  "Icon": "图标",
  "Group": "分组",
  "Link": "链接",
  "Save conditions": "保存筛选条件",
  "Edit menu item": "编辑菜单项",
  "Move to": "移动到",
  "Insert left": "在左边插入",
  "Insert right": "在右边插入",
  "Insert inner": "在里面插入",
  "Delete": "删除",
  "UI editor": "界面配置",
  "Collection": "数据表",
  "Collections & Fields": "数据表配置",
  "Roles & Permissions": "角色和权限",
  "Edit profile": "个人资料",
  "Change password": "修改密码",
  "Old password": "旧密码",
  "New password": "新密码",
  "Switch role": "切换角色",
  "Super admin": "超级管理员",
  "Language": "语言设置",
  "Allow sign up": "允许注册",
  "Sign out": "注销",
  "Cancel": "取消",
  "Submit": "提交",
  "Close": "关闭",
  "Set the data scope": "设置数据范围",
  "Data blocks": "数据区块",
  "Table": "表格",
  "Form": "表单",
  "Select data source": "选择数据源",
  "Calendar": "日历",
  "Kanban": "看板",
  "Select group field": "选择分组字段",
  "Media": "多媒体",
  "Markdown": "Markdown",
  "Wysiwyg": "富文本",
  "Charts": "图表",
  "Column chart": "柱状图",
  "Bar chart": "条形图",
  "Line chart": "折线图",
  "Pie chart": "饼图",
  "Templates": "模板",
  "Select template": "选择模板",
  "Action logs": "操作日志",
  "Create template": "创建模板",
  "Edit markdown": "编辑 Markdown",
  "Add block": "创建区块",
  "Add new": "添加",
  "Add record": "添加数据",
  "Custom field display name": "自定义字段名称",
  "Display fields": "显示字段",
  "Edit record": "编辑数据",
  "Delete menu item": "删除菜单项",
  "Add page": "添加页面",
  "Add group": "添加分组",
  "Add link": "添加链接",
  "Insert above": "在上面插入",
  "Insert below": "在下面插入",
  "Save": "保存",
  "Delete block": "删除区块",
  "Are you sure you want to delete it?": "你确定要删除吗？",
  "This is a demo text, **supports Markdown syntax**.": "这是一段演示文本，**支持 Markdown 语法**。",

  "Filter": "筛选",
  "Action type": "操作类型",
  "Actions": "操作",
  "Insert": "新增",
  "Update": "更新",
  "View": "查看",
  "View record": "查看数据",

  "Data changes": "数据变更",
  "Field name": "字段标识",
  "Before change": "变更前",
  "After change": "变更后",

  "Delete record": "删除数据",
  "Create collection": "创建数据表",
  "Collection display name": "数据表名称",
  "Collection name": "数据表标识",
  "Randomly generated and can be modified. Support letters, numbers and underscores, must start with an letter.": "随机生成，可修改。支持英文、数字和下划线，必须以英文字母开头。",
  "Storage type": "存储类型",
  "Edit": "编辑",
  "Edit collection": "编辑数据表",
  "Configure fields": "配置字段",
  "Configure columns": "配置字段",
  "Edit field": "编辑字段",
  "Configure fields of {{title}}": "「{{title}}」的字段配置",
  "Basic": "基本类型",
  "Single line text": "单行文本",
  "Long text": "多行文本",
  "Phone": "手机号码",
  "Email": "电子邮箱",
  "Number": "数字",
  "Percent": "百分比",
  "Password": "密码",
  "Choices": "选择类型",
  "Checkbox": "勾选",
  "Single select": "下拉菜单（单选）",
  "Multiple select": "下拉菜单（多选）",
  "Radio group": "单选框",
  "Checkbox group": "复选框",
  "China region": "中国行政区",
  "Attachment": "附件",
  "Date & Time": "日期 & 时间",
  "Datetime": "日期",
  "Relation": "关系类型",
  "Link to": "关联",
  "Sub-table": "子表格",
  "System info": "系统信息",
  "Created at": "创建日期",
  "Last updated at": "最后修改日期",
  "Created by": "创建人",
  "Last updated by": "最后修改人",
  "Add field": "添加字段",
  "Field display name": "字段名称",
  "Field type": "字段类型",
  "Field interface": "字段类型",
  "Date format": "日期格式",
  "Year/Month/Day": "年/月/日",
  "Year-Month-Day": "年-月-日",
  "Day/Month/Year": "日/月/年",
  "Show time": "显示时间",
  "Time format": "时间格式",
  "12 hour": "12 小时制",
  "24 hour": "24 小时制",

  "Add filter": "添加筛选条件",
  "Add filter group": "添加筛选分组",
  "is": "等于",
  "is not": "不等于",
  "contains": "包含",
  "does not contain": "不包含",
  "starts with": "开头是",
  "not starts with": "开头不是",
  "ends with": "结尾是",
  "not ends with": "结尾不是",
  "is empty": "为空",
  "is not empty": "不为空",
  "Edit chart": "编辑图表",
  "Add text": "添加文本",
  "Filterable fields": "可筛选字段",
  "Edit button": "编辑按钮",
  "Hide": "隐藏",
  "Enable actions": "启用操作",
  "Export": "导出",
  "Customize": "自定义",
  "Function": "Function",
  "Popup form": "Popup form",
  "Flexible popup": "Flexible popup",
  "Configure actions": "配置操作",
  "Display order number": "显示序号",
  "Enable drag and drop sorting": "启用拖拽排序",
  "Triggered when the row is clicked": "点击表格行时触发",
  "Add tab": "添加标签页",
  "Disable tabs": "禁用标签页",
  "Details": "详情",
  "Edit tab": "编辑标签页",
  "Relationship blocks": "关系数据区块",
  "Select record": "选择数据",
  "Display name": "显示名称",
  "Select icon": "选择图标",
  "Custom column name": "自定义列名称",
  "Edit description": "编辑描述",
  "Required": "必填",
  "Label field": "标签字段",
  "Default is the ID field": "默认为 ID 字段",
  "Set default sorting rules": "设置排序规则",

  "is before": "早于",
  "is after": "晚于",
  "is on or after": "不早于",
  "is on or before": "不晚于",

  "Upload": "上传",

  "Select level": "选择层级",
  "Province": "省",
  "City": "市",
  "Area": "区/县",
  "Street": "乡镇/街道",
  "Village": "村/居委会",
  "Must select to the last level": "必须选到最后一级",

  "Move {{title}} to": "将 {{title}} 移动到",
  "Target position": "目标位置",
  "After": "之后",
  "Before": "之前",

  "Add {{type}} before \"{{title}}\"": "在 \"{{title}}\" 前插入{{type}}",
  "Add {{type}} after \"{{title}}\"": "在 \"{{title}}\" 前插入{{type}}",
  "Add {{type}} in \"{{title}}\"": "在 \"{{title}}\" 里插入{{type}}",

  "Original name": "原名称",
  "Custom name": "自定义名称",
  "Custom Title": "自定义标题",

  "Options": "选项",
  "Option value": "选项值",
  "Option label": "选项",
  "Color": "颜色",
  "Add option": "添加选项",
  "Related collection": "关系表",
  "Allow linking to multiple records": "允许关联多条记录",
  "Allow uploading multiple files": "允许上传多个文件",

  "Configure calendar": "配置日历",
  "Title field": "标题字段",
  "Start date field": "开始日期字段",
  "End date field": "结束日期字段",
  "Navigate": "分页",
  "Title": "标题",
  "Select view": "切换视图",
  "Reset": "重置",
  "Export fields": "导出字段",
  "Saved successfully": "保存成功",
  "Nickname": "昵称",
  "Sign in": "登录",
  "Create an account": "注册账号",
  "Sign up": "注册",
  "Confirm password": "确认密码",
  "Log in with an existing account": "使用已有账号登录",
  "Signed up successfully. It will jump to the login page.": "注册成功，将跳转登录页。",
  "Password mismatch": "确认密码不匹配",
  "Users": "用户",

  "Roles": "角色",
  "Add role": "添加角色",
  "Role name": "角色名称",
  "Configure": "配置",
  "Configure permissions": "配置权限",
  "Edit role": "编辑角色",

  "Action permissions": "数据表操作权限",
  "Menu permissions": "菜单访问权限",

  "Menu item name": "菜单名称",
  "Allow access": "允许访问",

  "Action name": "操作名称",
  "Allow action": "允许操作",
  "Action scope": "可操作数据范围",
  "Operate on new data": "对新增数据操作",
  "Operate on existing data": "对已有数据操作",

  "Yes": "是",
  "No": "否",

  "Red": "薄暮",
  "Magenta": "法式洋红",
  "Volcano": "火山",
  "Orange": "日暮",
  "Gold": "金盏花",
  "Lime": "青柠",
  "Green": "极光绿",
  "Cyan": "明青",
  "Blue": "拂晓蓝",
  "Geek Blue": "极客蓝",
  "Purple": "酱紫",
  "Default": "默认",

  "Add card": "添加卡片",
  "edit title": "修改标题",
  "Turn pages": "翻页",
  "Others": "其他",
  "Save as template": "保存为模板",
  "Block templates": "区块模板",
  "Convert reference to duplicate": "模板引用转为复制",
  "Template name": "模板名称",
  "Block type": "区块类型",
  "Action column": "操作列",
  "Records per page": "每页显示数量",
  "(Fields only)": "（仅字段）",
  "Button title":  "按钮标题",
  "Button icon":  "按钮图标",
  "Submitted successfully": "提交成功",
  "Open mode": "打开方式",
  'Menu item title': '菜单项名称',
  'Menu item icon': '菜单项图标',
  'Target': '目标',
  'Position': '位置',
  'Insert before': '在前面插入',
  'Insert after': '在后面插入',
  'UI Editor': '界面配置',
  'ASC': '升序',
  'DESC': '降序',
  'Add sort field': '添加排序字段',
  'ID': 'ID',
  'Drawer': '抽屉',
  'Dialog': '对话框',
  'Delete action': '删除操作',
  'Custom column title': '自定义列标题',
  'Original title: ': '原始标题: ',
  'Delete table column': '删除列',

  'Skip required validation': '跳过必填校验',
  'Form values': '表单值',
  'Fields values': '字段值',
  'When submitting the following fields, the saved values are': '提交以下字段时，保存的值为',
  'After successful submission': '提交成功后',
  'Then': '然后',
  'Stay on current page': '停留在当前页面',
  'Redirect to': '跳转到',
  'Save action': '保存操作',

  'Exists': '存在',
  'Filename': '文件名',
  'Add condition': '添加条件',
  'Add condition group': '添加条件分组',
  'exists': '存在',
  'not exists': '不存在',
  'is current logged-in user': '为当前登录用户',
  '=': '=',
  '≠': '≠',
  '>': '>',
  '≥': '≥',
  '<': '<',
  '≤': '≤',
  'Role UID': '角色标识',

  'Precision': '精确度',
  'Accept': '文件格式',
  'Rich Text': '富文本',
  'Junction collection': '中间表',
  'Fields': '字段',
  'Edit field title': '编辑字段标题',
  'Field title': '字段标题',
  'Original field title: ': '原始字段标题：',
  'Edit tooltip': '编辑提示信息',
  'Delete field': '删除字段',

  'Select collection': '选择数据表',
  'Blank block': '空区块',
  'Duplicate template': '复制模板',
  'Reference template': '引用模板',

  'Create calendar block': '创建日历区块',
  'Create kanban block': '创建看板区块',
  'Group field': '分组字段',

  'Tab name': '标签名称',
  'Current record blocks': '当前数据区块',

  'Pop-up message': '弹窗提示消息',

  'Delete role': '删除角色',

  'Role display name': '角色名称',
  'Default role': '默认角色',
  'All collections use general action permissions by default; permission configured individually will override the default one.': '所有数据表都默认使用通用数据操作权限；同时，可以针对每个数据表单独配置权限。',
  'Allows configuration of the whole system, including UI, collections, permissions, etc.': '允许配置系统，包括界面配置、数据表配置、权限配置、系统配置等全部配置项',
  'New menu items are allowed to be accessed by default.': '新增菜单项默认允许访问',
  'Global permissions': '全局配置',
  'General permissions': '通用配置',
  'Global action permissions': '全局操作权限',
  'General action permissions': '通用操作权限',
  'Action display name': '操作名称',
  'Allow': '允许',
  'Data scope': '数据范围',
  'Action on new records': '对新增数据操作',
  'Action on existing records': '对已有数据操作',
  'All records': '所有数据',
  'Own records': '自己的数据',
  'Permission policy': '权限策略',
  'Individual': '单独配置',
  'General': '通用配置',
  'Accessible': '允许访问',
  'Configure permission': '配置权限',
  'Action permission': '操作权限',
  'Field permission': '字段权限',
  'Scope name': '数据范围名称',

  'File storages': '文件存储',
  'Storage display name': '文件存储名称',
  'Storage name': '文件存储标识',
  'Default storage': '默认存储',
  'Add storage': '添加文件存储',
  'Edit storage': '编辑文件存储',
  'Storage base URL': 'Base URL',
  'Destination': '文件路径',
  'Use the built-in static file server': '使用内置静态文件服务',
  'Local storage': '本地存储',
  'Aliyun OSS': '阿里云 OSS',
  'Amazon S3': '亚马逊 S3',

  // plugins/workflow
  'Workflow': '工作流',
  'Execution History': '执行历史',
  'Trigger type': '触发方式',
  'Description': '描述',
  'Status': '状态',
  'Started': '启用',
  'Stopped': '停用',
  'Version': '版本',
  'Copy to new version': '复制到新版本',

  'Load failed': '加载失败',

  'Trigger': '触发器',
  'Collection event': '数据表事件',
  'Trigger on': '触发时机',
  'After record added': '新增数据后',
  'After record updated': '更新数据后',
  'After record added or updated': '新增或更新数据后',
  'After record deleted': '删除数据后',
  'Changed fields': '发生变动的字段',
  'Triggered only if one of the selected fields changes. If unselected, it means that it will be triggered when any field changes. When record is added or deleted, any field is considered to have been changed.': '只有被选中的某个字段发生变动时才会触发。如果不选择，则表示任何字段变动时都会触发。新增或删除数据时，任意字段都被认为发生变动。',
  'Only triggers when match conditions': '满足以下条件才触发',

  'End': '结束',

  'Trigger context': '触发数据',
  'Node result': '节点数据',
  'Constant': '常量',

  'Boolean': '逻辑值',
  'String': '字符串',

  'Comparison': '值比较',
  'Arithmetic calculation': '算术运算',
  'String operation': '字符串',

  'On going': '进行中',
  'Success': '成功',
  'Failed': '失败',
  'Canceled': '已取消',

  'This node contains branches, deleting will also be preformed to them, are you sure?': '节点包含分支，将同时删除其所有分支下的子节点，确定继续？',

  'Control': '流程控制',
  'Collection operations': '数据表操作',

  'Node type': '节点类型',

  'Calculation': '运算',
  'Configure calculation': '配置运算',
  'Calculation result': '运算结果',
  'True': '真',
  'False': '假',

  'Condition': '条件判断',
  'Mode': '模式',
  'Continue when "Yes"': '“是”则继续',
  'Branch into "Yes" and "No"': '“是”和“否”分别继续',
  'Conditions': '条件配置',

  'Parallel branch': '分支',
  'All succeeded': '全部成功',
  'Any succeeded': '任意成功',
  'Continue after all branches succeeded': '全部分支都成功后才能继续',
  'Continue after any branch succeeded': '任意分支成功后就继续',

  'Create record': '新增数据',
  'Update record': '更新数据',
  'Query record': '查询数据',
  'Multiple records': '多条数据',
  'Please select collection first': '请先选择数据表',
  'Only update records matching conditions': '只更新满足条件的数据',
  'Fields that are not assigned a value will be set to the default value, and those that do not have a default value are set to null.': '未被赋值的字段将被设置为默认值，没有默认值的设置为空值。',
  'Trigger in executed workflow cannot be modified': '已经执行过工作流的触发器不能被修改',
  'Node in executed workflow cannot be modified': '已经执行过工作流中的节点不能被修改',

  'Unsaved changes': '未保存修改',
  'Are you sure you don\'t want to save?': '你确定不保存修改吗？',
  'Dragging': '拖拽中',
}
